const OFFSET = 400;
// Storybook can rerender this story when the active theme changes.
// Keep a single set of global listeners and always resolve the current button from the DOM.
let isInitialized = false;

function updateButtonVisibility() {
    const button = document.querySelector('.back-to-top');

    if (!button) {
        return;
    }

    button.style.bottom = window.scrollY > OFFSET ? '20px' : '-60px';
}

function handleButtonClick(event) {
    // Use event delegation so a newly rendered button keeps working without rebinding.
    const button = event.target.closest('.back-to-top');

    if (!button) {
        return;
    }

    event.preventDefault();

    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
}

export function initBackToTop() {
    if (!isInitialized) {
        // Bind once to avoid stacking duplicate listeners after repeated story renders.
        window.addEventListener('scroll', updateButtonVisibility);
        document.addEventListener('click', handleButtonClick);
        isInitialized = true;
    }

    // Sync the current button immediately in case the page is already scrolled.
    updateButtonVisibility();
}
